import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-printer",
  "use": "icon-s-printer-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-printer\"><path d=\"M17 0v4h3a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-3v5H5v-5H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h3V0zm-2 12H7v8h8zm5-6H2v9h3v-5h12v5h3zm-2 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-3-5H7v2h8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol